
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cellline",
      function () {
        return require("private-next-pages/cellline.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cellline"])
      });
    }
  